import { render, staticRenderFns } from "./gasClampUpstream.vue?vue&type=template&id=bd2f27b2&scoped=true"
import script from "./gasClampUpstream.vue?vue&type=script&lang=js"
export * from "./gasClampUpstream.vue?vue&type=script&lang=js"
import style0 from "./gasClampUpstream.vue?vue&type=style&index=0&id=bd2f27b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2f27b2",
  null
  
)

export default component.exports